import React, { useContext } from "react";
import { FilterContext } from "../filters-context";
import useMediaQuery from "@mui/material/useMediaQuery";

const TailleFilter = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const onTailleClick = () => {
    if (filters.openedFilter === "taille") {
      setOpenedFilter(null);
    } else {
      setOpenedFilter("taille");
    }
  };
  const selectTaille = (taille) => {
    setTaille(taille);
  };

  const handleChange = (event) => {
    const taille = innovantsFilters.taille.find((taille) => {
      return event.target.value === taille.id;
    });
    setTaille(taille);
  };
  const { filters, setTaille, setOpenedFilter } = useContext(FilterContext);
  return (
    <>
      {innovantsFilters &&
        innovantsFilters.taille &&
        innovantsFilters.taille.length > 0 && (
          <div
            className={`filter-container ${
              filters.openedFilter === "taille" ? "is-open" : ""
            }`}
          >
            <button
              className={`filter-button ${
                filters.taille && filters.taille.label ? "is-selected" : ""
              }`}
              onClick={() => {
                onTailleClick();
              }}
            >
              {filters.taille && filters.taille.label
                ? filters.taille.label
                : "Filtrer par taille de l’entreprise"}
            </button>
            {isMobile ? (
              <select
                name="taille-select"
                onChange={handleChange}
                value={filters.taille?.id || ""}
              >
                <option value={""}>Toutes les tailles</option>
                {innovantsFilters.taille.map((taille) => {
                  return (
                    <option key={taille.id} value={taille.id}>
                      {taille.label}
                    </option>
                  );
                })}
              </select>
            ) : (
              <ul className="filter-list">
                {filters.taille && filters.taille.label && (
                  <li>
                    <button
                      onClick={() => {
                        selectTaille(null);
                      }}
                    >
                      Toutes les tailles
                    </button>
                  </li>
                )}
                {innovantsFilters.taille.map((taille) => (
                  <li key={taille.id}>
                    <button
                      onClick={() => {
                        selectTaille(taille);
                      }}
                      id={taille.id}
                    >
                      {taille.label}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
    </>
  );
};

export default TailleFilter;
